export const BcFeatures = {
  SMART_RESPONSE: 'lc_smart_response',
  FB_SMART_RESPONSE: 'fb_smart_response',
  SM_SMART_RESPONSE: 'sm_smart_response',
  ABC_SMART_RESPONSE: 'abc_smart_response',
  AM_SMART_RESPONSE: 'am_smart_response',
  AM_INACTIVE_STATE_HANDLING: 'am_inactive_state_handling',
  FB_ACCOUNT: 'fb_account',
  ABC_ACCOUNT: 'abc_account',
  AM_ACCOUNT: 'am_account',
  SM_DISABLED: 'sm_disabled',
  LC_DISCUSSIONS: 'lc_discussions',
  LC_DISCUSSIONS_ACD: 'lc_discussions_acd',
  LC_INTEGRATIONS_NANOREP: 'lc_integrations_nanorep',
  LC_QUEUE_VIEW: 'lc_queue_view',
  LC_SHOW_USER_QUERIES_NANOREP: 'lc_show_user_queries_nanorep',
  LC_AGENT_STATS: 'lc_agent_stats',
  LC_AGENT_LIST: 'lc_agent_list',
  LC_VIDEO_CHAT: 'lc_videochat',
  LC_NEW_VIDEO_CHAT: 'lc_new_videochat',
  LC_VISIT_INFO_CUSTOM_FIELDS: 'lc_visit_info_custom_fields',
  RC_NEW_REMOTE_CONTROL: 'rc_new_remote_control',
  VM_CIH_REAL_TIME_DATA_SYNC: 'vm_cih_real_time_data_sync',
  VM_CUSTOMER_INFORMATION_HUB: 'vm_customer_information_hub'
};
